/**
 * Prevent emojis being entered into inputs/textareas on the site
 * * Need to listen for DOMNodeInserted because BOLD/SC Products inserts its fields
 * * post page load with JavaScript
 *
 * @author Matt <matt@joipolloi.com>
 * @package Minifigs 2.0
 */

const stripEmojis = (str) =>
    str
        .replace(
            /(?![*#0-9]+)[\p{Emoji}\p{Emoji_Modifier}\p{Emoji_Component}\p{Emoji_Modifier_Base}\p{Emoji_Presentation}]/gu,
            ''
        )
        .replace(/\s+/g, ' ');

const preventEmojis = () => {
    const productContainer = document.querySelector('.product');
    if (!productContainer) return;

    const handleNodeUpdate = () => {
        const inputs = document.querySelectorAll('textarea, input[type="text"] ');
        inputs.forEach((input) =>
            input.addEventListener('input', () => {
                const strippedValue = stripEmojis(input.value);
                input.value = strippedValue;
            })
        );
    };

    const observer = new MutationObserver((mutationList) =>
        mutationList
            .filter((m) => m.type === 'childList')
            .forEach((m) => {
                m.addedNodes.forEach(handleNodeUpdate);
            })
    );
    observer.observe(productContainer, { childList: true, subtree: true });
};

export default preventEmojis;
